
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vidya",
      function () {
        return require("private-next-pages/vidya/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vidya"])
      });
    }
  